import type { Ref, TextareaHTMLAttributes } from "react";
import { cx } from "../../lib/cx";

export type TextareaProps = {
  invalid?: boolean;
  ref?: Ref<HTMLTextAreaElement>;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = ({ invalid = false, className, ref, ...rest }: TextareaProps) => (
  <div data-state={invalid ? "error" : "default"} className={className}>
    <textarea ref={ref} className={cx("form-control", invalid && "is-invalid")} {...rest} />
  </div>
);
